function normalizeApiBaseUrl(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return 'http://127.0.0.1:8000';
  return s.replace(/\/+$/, '');
}

/** Ordem: variável CRA (.env) → override em runtime (index.html) → defeito local Laravel. */
const envUrl =
  typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : undefined;
const runtimeUrl = typeof window !== 'undefined' ? window.__SIENGE_API_URL__ : undefined;

const CONFIG_BACKEND = Object.freeze({
  baseUrl: normalizeApiBaseUrl(envUrl || runtimeUrl || 'http://127.0.0.1:8000'),
  docsPath: '/docs/api',
});

export { CONFIG_BACKEND };
